import React from 'react';
import ReactDOM from 'react-dom';
import TutorOnboarding from '../components/TutorOnboarding';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderTutorOnboarding = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<TutorOnboarding props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering TutorOnboarding:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};